import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const getScrollKey = (location) => `scroll-position:${location.pathname}${location.search}`;

function ScrollToTop() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const previousPathname = useRef(null);

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    const scrollKey = getScrollKey(location);
    const savePosition = () => {
      window.sessionStorage.setItem(scrollKey, String(window.scrollY));
    };

    window.addEventListener("beforeunload", savePosition);

    return () => {
      savePosition();
      window.removeEventListener("beforeunload", savePosition);
    };
  }, [location]);

  useEffect(() => {
    const samePage = previousPathname.current === location.pathname;
    previousPathname.current = location.pathname;
    // Keep catalog controls in view while updating search and category filters.
    if (samePage && navigationType !== "POP") return;

    if (navigationType === "POP") {
      const savedPosition = Number(window.sessionStorage.getItem(getScrollKey(location)));

      if (!Number.isNaN(savedPosition)) {
        window.requestAnimationFrame(() => window.scrollTo(0, savedPosition));
        return;
      }
    }

    window.scrollTo(0, 0);
  }, [location, navigationType]);

  return null;
}

export default ScrollToTop;
